module.exports = __webpack_public_path__ + "static/media/phone-square.04045ca4.svg";